import{a as i}from"./chunk-LD3Z6ZPJ.js";import{b as t,c as e}from"./chunk-TJAPTG4H.js";import{a as n}from"./chunk-RQEG7WSF.js";import{m as o}from"./chunk-HBP5N4FR.js";o();e();n();function s(r){i.dispatch(t({address:r,loginMethod:"extra"}))}export{s as a};
//# sourceMappingURL=chunk-7E6Z6OTW.js.map
